import { Separator } from "@/components/ui/separator";
import { useState, useEffect } from "react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { reservationLinks } from "@/components/lib/SidebarLinks";
import DraftList from "./tabs/draft-list-tabs";
import ListTabs from "./tabs/reservation-list-tabs";
import CancelListTabs from "./tabs/cancel-list-tabs";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import Paginat from "@/components/lib/paginat";
import useAuth from "@/hooks/useAuth";
import StaffTableSkeleton from "@/components/skeleton/Staff-skeletion";
import { Link } from "react-router-dom";
import { fetchReservations } from "@/redux/slice/reservation-slice/reservation-slice";
import hasPermission from "@/hooks/hasPermission";

function ReservationList() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { user } = useAuth();
  const [status, setStatus] = useState(() => {
  const tab = JSON.parse(localStorage.getItem("tabs-data"))?.["reservation-list-tabs"]?.default;
    return tab === "cancelled" ? "cancelled" : tab === "draft" ? "draft" : "";
  });

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [firstLoading, setFirstLoading] = useState(true);
  const [search, setSearch] = useState("");
  const { reservations, pagination, summary } = useSelector(
    (state) => state.reservation.reservation
  );

  useEffect(() => {
    const fetchData = async () => {
      if (firstLoading) {
        setFirstLoading(true);
      }
      const res = await dispatch(
        fetchReservations({
          page: page,
          limit: perPage,
          restaurant_id: user?.restaurant_id,
          status: status,
          start_date: startTime,
          end_date: endTime,
          search: search
        })
      );
      if (fetchReservations.fulfilled.match(res)) {
        setFirstLoading(false);
      } else if (fetchReservations.rejected.match(res)) {
        setFirstLoading(false);
        toast.error(res.payload);
      }
    };
    fetchData();
  }, [page, perPage, status, startTime, endTime, search]);

  if (firstLoading) return <StaffTableSkeleton links={reservationLinks} />;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={reservationLinks} />}
      pageName={{ title: "Reservation List" }}
      paths={[
        { name: "Home", path: "/home" },
        { name: "Reservation", path: "/reservation" },
        {
          name: "Reservation List",
          path: "/reservation",
        },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-2">
        <div className="flex justify-end">
          {
            hasPermission("reservation.reservation_list.create_reservation") && (
            <Link to={"/reservation/reservation-request/create"}>
              <Button>Add New Reservation</Button>
            </Link>
            )}
        </div>

        <div>
          <div className="w-full flex justify-between lg:flex-row flex-col gap-5 md:gap-20 items-start lg:items-center">
            <div className=" w-full grid grid-cols-3 gap-5 md:grid-cols-4 ">
              <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
                <div className="space-y-1 text-white">
                  <h2>Total Request</h2>
                  <h2 className="text-lg font-bold text-cwhite">
                    {summary?.total_requests || "0"}
                  </h2>
                </div>
              </div>
              <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
                <div className="space-y-1 text-white">
                  <h2 className="text-sm xl:text-base">Total Cancelled</h2>
                  <h2 className="text-lg font-bold text-cred">
                    {summary?.total_cancelled || "0"}
                  </h2>
                </div>
              </div>
              <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
                <div className="space-y-1 text-white">
                  <h2 className="text-sm lg:text-base">
                    Total Approve Request
                  </h2>
                  <h2 className="text-lg font-bold text-cgreen">
                    {summary?.total_confirmed || "0"}
                  </h2>
                </div>
              </div>
              <div className="bg-cblack3 py-2 px-4 flex gap-5 rounded-md border border-gray-700">
                <div className="space-y-1 text-white">
                  <h2 className="text-sm lg:text-base">Total Guest</h2>
                  <h2 className="text-lg font-bold text-cblue">
                    {summary?.total_guests || "0"}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-5 justify-between mt-5 w-full items-center">
            <Tabs
              valueKey="reservation-list-tabs"
              className="bg-transparent relative w-full"
              defaultValue="list"
            >
              <TabsList className="flex w-full justify-start">
                <Separator className="absolute top-8" />
                <TabsTrigger
                  onClick={() => {setStatus(""); setPage(1); setPerPage(10)}}
                  className="bg-transparent"
                  value="list"
                >
                  Reservation List
                </TabsTrigger>
                <TabsTrigger
                  onClick={() => {setStatus("cancelled"); setPage(1); setPerPage(10)}}
                  className="bg-transparent"
                  value="cancelled"
                >
                  Cancelled
                </TabsTrigger>
                <TabsTrigger onClick={() => {setStatus("draft"); setPage(1); setPerPage(10)}} value="draft">
                  Draft List
                </TabsTrigger>
              </TabsList>
              <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
              <DraftList
                data={reservations}
                perPage={perPage}
                setPerPage={setPerPage}
                setStartTime={setStartTime}
                setEndTime={setEndTime}
                setSearch={setSearch}
              />
              <ListTabs
                data={reservations}
                perPage={perPage}
                setPerPage={setPerPage}
                setStartTime={setStartTime}
                setEndTime={setEndTime}
                setSearch={setSearch}
              />
              <CancelListTabs
                data={reservations}
                perPage={perPage}
                setPerPage={setPerPage}
                setStartTime={setStartTime}
                setEndTime={setEndTime}
                setSearch={setSearch}
              />
            </Tabs>
          </div>
          <Paginat
            className="mt-2"
            pagination={pagination}
            onPageChange={(page) => setPage(page)}
          />
        </div>
      </div>
    </Layout2>
  );
}

export default ReservationList;
